import { render, staticRenderFns } from "./ListIdeaCardVersioning.vue?vue&type=template&id=3321736e&"
import script from "./ListIdeaCardVersioning.vue?vue&type=script&lang=js&"
export * from "./ListIdeaCardVersioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports